<template>
  <div class="copyright-block container">
    Указанная стоимость товаров и&nbsp;условия их&nbsp;приобретения действительны по&nbsp;состоянию на&nbsp;текущую дату.
    <recaptcha-text />
    <br><br>
    &copy;&nbsp;2022, FUNDAY. Все права защищены. Юридический адрес: г. Москва, ул. Профсоюзная, д. 61А
  </div>
</template>

<script>
import recaptchaText from '@/components/common/recaptchaText';
export default {
  name: 'copyright-block',
  components: {
    recaptchaText,
  },
};
</script>

<style lang="scss">
.copyright-block {
  margin-top: 24px;
  padding-bottom: 16px;
  color: $gray;
  font-size: 12px;
  line-height: 16px;

  &::before {
    display: block;
    width: 100%;
    height: 1px;
    margin-bottom: 16px;
    background-color: $gray-lu;
    content: "";
  }

  & > a {
    color: $black;
  }
}

@include breakpoint("tablet") {
  .copyright-block {
    margin-top: 0;
    padding-bottom: 32px;
  }
}
@include breakpoint("desktop") {
  .copyright-block {
    margin-top: 56px;
    padding-bottom: 56px;
  }
}
</style>